<template>
  <div v-if="favoriteTables.length > 0" class="sidebar__section">
    <ul class="tree">
      <li>
        <div
          class="tree__heading tree__heading--collapsible"
          @click="toggleCollapsed()"
        >
          <i
            class="tree__heading-caret"
            :class="
              collapsed ? 'iconoir-nav-arrow-right' : 'iconoir-nav-arrow-down'
            "
          ></i>
          <div class="tree__heading-name">{{ $t('sidebar.favorites') }}</div>
        </div>
        <ul v-show="!collapsed" class="tree">
          <li
            v-for="favorite in favoriteTables"
            :key="'favorite-' + favorite.table.id"
            class="tree__sub"
            :class="{ active: isTableActive(favorite.table) }"
          >
            <a
              class="tree__sub-link"
              :title="favorite.table.name"
              @click.prevent="selectTable(favorite)"
            >
              <i class="tree__sub-favorite-icon iconoir-star"></i>
              {{ favorite.table.name }}
            </a>
            <span v-if="openCount(favorite.table)" class="tree__sub-count">{{
              openCount(favorite.table)
            }}</span>
            <a
              v-tooltip="$t('sidebar.removeFavorite')"
              class="tree__options tree__options--unstar"
              @click.stop="unstar(favorite.table)"
            >
              <i class="iconoir-star-dashed"></i>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { notifyIf } from '@baserow/modules/core/utils/error'
import {
  readCollapsedSections,
  writeCollapsedSections,
} from '@baserow/modules/core/utils/sidebarCollapse'

const COLLAPSE_KEY = 'favorites'

/**
 * Seção "Favoritos" da sidebar (estilo ClickUp): tabelas marcadas com a
 * estrela do breadcrumb da tabela. Some quando não há favoritos no
 * workspace selecionado.
 */
export default {
  name: 'SidebarFavorites',
  props: {
    selectedWorkspace: {
      type: Object,
      required: true,
    },
    applications: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      collapsed: false,
    }
  },
  computed: {
    starredTableIds() {
      return this.$store.getters['favorites/getTableIds']
    },
    /**
     * Resolve os ids favoritados para tabelas reais do workspace
     * selecionado. Favoritos de tabelas apagadas ou de outros workspaces
     * ficam de fora naturalmente.
     */
    favoriteTables() {
      const results = []
      for (const application of this.applications) {
        if (
          application.type !== 'database' ||
          application.workspace.id !== this.selectedWorkspace.id
        ) {
          continue
        }
        for (const table of application.tables || []) {
          if (this.starredTableIds.includes(table.id)) {
            results.push({ database: application, table })
          }
        }
      }
      return results.sort((a, b) => a.table.name.localeCompare(b.table.name))
    },
  },
  mounted() {
    this.$store.dispatch('favorites/load').catch(() => {
      // Sem favoritos a seção só não aparece.
    })
    this.collapsed = !!readCollapsedSections()[COLLAPSE_KEY]
  },
  methods: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed
      const sections = readCollapsedSections()
      if (this.collapsed) {
        sections[COLLAPSE_KEY] = true
      } else {
        delete sections[COLLAPSE_KEY]
      }
      writeCollapsedSections(sections)
    },
    isTableActive(table) {
      return parseInt(this.$route.params.tableId) === table.id
    },
    selectTable({ database, table }) {
      this.$router.push({
        name: 'database-table',
        params: { databaseId: database.id, tableId: table.id },
      })
    },
    unstar(table) {
      this.$store.dispatch('favorites/toggleTable', table.id).catch(notifyIf)
    },
    openCount(table) {
      if (!this.$store.hasModule('tableCounts')) {
        return null
      }
      return this.$store.getters['tableCounts/getOpenCount'](table.id)
    },
  },
}
</script>
